import styled, { css } from 'styled-components';
import { SvgHelperWrapper } from 'src/components';

export const LoadingWrapper = styled.div(
  ({ theme }) => css`
    margin-bottom: ${theme.sz.s4};

    div:first-child {
      min-height: ${theme.sz.s16};
    }
  `,
);

export const Banner = styled.div(
  ({ theme }) => css`
    background-color: ${theme.co.primary98};
    border-radius: ${theme.bo.mediumSmall};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: ${theme.DEPRECATED_ty.mediumLarge};
    padding: ${theme.sz.s4};
    margin-bottom: ${theme.sz.s4};

    @media (max-width: ${theme.sz.ms}) {
      flex-direction: column;
      padding: ${theme.sz.s2};
    }

    &:hover,
    &:focus {
      background-color: ${theme.co.primary90};
    }
  `,
);

export const ContentWrapper = styled.div(
  ({ theme }) => css`
    width: 100%;
    display: flex;
    color: ${theme.co.secondary20};
  `,
);

export const TextWrapper = styled.div(
  () => css`
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  `,
);

export const Text = styled.div(
  ({ theme }) => css`
    flex: 0 0 auto;
    font-weight: ${theme.DEPRECATED_ty.bold};
    margin-right: ${theme.sz.s4};

    @media (max-width: ${theme.sz.ms}) {
      font-size: ${theme.DEPRECATED_ty.medium};
    }
  `,
);

export const Description = styled.div<{ $desktopOnly: boolean }>(
  ({ theme, $desktopOnly }) => css`
    ${$desktopOnly &&
    css`
      @media (max-width: ${theme.sz.xxl}) {
        display: none;
      }
    `}
  `,
);

export const PriceWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    margin-right: ${theme.sz.s4};
    margin-left: ${theme.sz.s6};
    @media (max-width: ${theme.sz.xxl}) {
      margin-right: 0;
      margin-left: ${theme.sz.s4};
    }

    @media (max-width: ${theme.sz.lg}) {
      display: none;
    }
  `,
);

export const OriginalPrice = styled.div(
  ({ theme }) => css`
    color: ${theme.co.secondary20};
    font-weight: ${theme.DEPRECATED_ty.bold};
    text-decoration: line-through;
    margin-left: ${theme.sz.s4};

    @media (max-width: ${theme.sz.xxl}) {
      font-size: ${theme.DEPRECATED_ty.small};
    }
  `,
);
export const StarWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    margin-right: ${theme.sz.s4};

    svg {
      height: ${theme.sz.s8};
      width: ${theme.sz.s8};
    }
  `,
);

export const PremiumStar = styled(SvgHelperWrapper)(
  () => css`
    width: 100%;
    height: 100%;
  `,
);

export const ButtonWrapper = styled.div(
  ({ theme }) => css`
    flex: 0 0 auto;
    margin-left: ${theme.sz.s4};

    @media (max-width: ${theme.sz.ms}) {
      width: 100%;
      margin-right: ${theme.sz.s4};
      margin-top: ${theme.sz.s4};
    }
  `,
);
